import { SET_UPLOAD_STATUS_VISIBILITY } from 'actions/Types';

export default (state = false, action) => {
  if (action.type === SET_UPLOAD_STATUS_VISIBILITY) {
    return action.payload;
  }

  return state;
};
